import React from 'react';
import { Box, Typography } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { Value } from './Value';
import { Pair } from '../../hooks/useExchangeRate';

interface Props {
  pair: Pair;
}

export const ExchangeRate: React.FC<Props> = ({ pair }) => {
  const { t } = useTranslation('conversion');

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      <Typography.Text>{t('Exchange rate')}</Typography.Text>
      <Typography.Text>
        <Value pair={pair} />
      </Typography.Text>
    </Box>
  );
};
